<!-- PAGE TITLE================================================== -->

<section class="bg-light-red page-title-section top-position1 bg-img cover-background left-overlay-secondary">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center">
                    <div class="position-relative">
                        <h1>About Us</h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- ABOUT
        ================================================== -->
<!-- <section class="overflow-hidden position-relative about-style-03 bg-light-yellow">
    <div class="container">
        <div class="row align-items-center position-relative z-index-9">
            <div class="col-lg-6 col-xxl-auto wow fadeInUp" data-wow-delay="100ms">
                <div class="px-xxl-4 mx-xxl-3 pb-md-4 pb-lg-0">
                    <div class="about-img-box">                       
                        <div class="img-1 image-hover">
                            <img src="/assets/images/aboutus.jpg" alt="About Us" loading="lazy" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 col-xxl wow fadeInUp" data-wow-delay="200ms">
                <div class="ps-lg-0 ps-xl-0">
                    <div class="section-title-02 mb-2 position-relative">
                       
                        <h2 class="mb-0">
                            About Red Monk Wellness
                        </h2>
                     
                    </div>
                    <p class="mb-1-5">
                        IV Therapy is transforming the health and wellness landscape by offering fast, effective
                        solutions
                        tailored to a wide range of wellness and cosmetic needs.<strong> Red Monk Wellness</strong>, has
                        adopted
                        the latest advancements in scientific and medical research to bring you a variety of IV
                        therapies
                        designed to meet your unique requirements- all at your convenience and delivered directly to
                        your
                        doorstep.
                    </p>
                    <p class="mb-1-5">
                        Our IV therapies are administered and closely monitored by highly qualified doctors and medical
                        professionals, ensuring your safety and well-being throughout the process. We pride ourselves on
                        being
                        quick, dependable, trustworthy, and affordable. Each therapy blend is meticulously crafted by
                        our
                        doctors, taking into account your comprehensive health reports and individual body type, to
                        provide you
                        with optimal results.
                    </p>
                </div>
            </div>
        </div>
    </div>  
</section> -->


<!-- Dynamic -->

<!-- ABOUT (one block per active row) -->
@for (a of items(); track a.ID; let odd = $odd) {
  <section class="overflow-hidden position-relative about-style-03 bg-light-yellow">
    <div class="container">
      <div class="row align-items-center position-relative z-index-9" [class.flex-row-reverse]="odd">
        <div class="col-lg-6 col-xxl-auto wow fadeInUp" data-wow-delay="100ms">
          <div class="px-xxl-4 mx-xxl-3 pb-md-4 pb-lg-0">
            <div class="about-img-box">
              <div class="img-1 image-hover">
                <img [src]="imgUrl(a.ImagePath)" [alt]="a.Title" />
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-xxl wow fadeInUp" data-wow-delay="200ms">
          <div class="ps-lg-0 ps-xl-0">
            <div class="section-title-02 mb-2 position-relative">
              <h2 class="mb-0">{{ a.Title }}</h2>
            </div>
            <div class="about-desc" [innerHTML]="a.Description"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
}

@if (!loading() && !error() && items().length === 0) {
  <p class="text-center">No content available.</p>
}
@if (error()) {
  <p class="text-center">Unable to load content right now.</p>
}